import { useLocation, useNavigate } from "react-router-dom";
import "../assets/css/packageDetails.css";

function PackageDetails() {

    const { state } = useLocation();
    const navigate = useNavigate();

    if (!state) {

        return (

            <div className="customer-package-details-notfound">

                <h1>Package Not Found</h1>

            </div>

        );

    }

    const { title, image, price, features } = state;

    return (

        <section className="customer-package-details-page">

            <div className="customer-package-details-container">

                <div className="customer-package-details-image">

                    <img
                        src={image}
                        alt={title}
                    />

                    <div className="customer-package-details-price">
                        {price}
                    </div>

                </div>

                <div className="customer-package-details-content">

                    <span className="customer-package-details-tag">
                        STORY LINE STUDIOS
                    </span>

                    <h1 className="customer-package-details-title">
                        {title}
                    </h1>

                    <p className="customer-package-details-description">
                        Experience a premium photography package crafted to preserve your most precious memories with cinematic elegance, artistic storytelling, and luxury presentation.
                    </p>

                    <h3 className="customer-package-details-heading">
                        Package Includes
                    </h3>

                    <ul className="customer-package-details-features">

                        {(features || []).map((item, index) => (

                            <li key={index}>
                                {item}
                            </li>

                        ))}

                    </ul>

                    <button
                        className="customer-package-details-button"
                        onClick={() => navigate("/contact")}
                    >

                        Book This Package →

                    </button>

                </div>

            </div>

        </section>

    );

}

export default PackageDetails;